import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ATMPageHeader from "src/components/UI/atoms/ATMPageHeader/ATMPageHeader";
import ATMPagination from "src/components/UI/atoms/ATMPagination/ATMPagination";
import ATMTable, {
  columnTypes,
} from "src/components/UI/atoms/ATMTable/ATMTable";
import SideNavLayout from "src/components/layouts/SideNavLayout/SideNavLayout";
import { isCheckActionsPermission } from "src/helpers/userAccessFun";
import { UserModuleActionTypes, UserModuleNameTypes } from "src/models/userAccess/UserAccess.model";
import StudentFilterDialogWrapper from "./FilterCard/StudentFilterDialogWrapper";

type Props = {
  columns: columnTypes[];
  rows: any[];
  paginationProps: {
    isTableLoading: boolean;
    totalItems: number;
    page: number;
    rowsPerPage: number;
    searchValue: string;
    setPage: (newPage: number) => void;
    setRowsPerPage: (newLimit: number) => void;
    setSearchValue: (newValue: string) => void;
  };
};

const StudentListing = ({
  columns,
  rows,
  paginationProps: {
    isTableLoading,
    totalItems,
    page,
    rowsPerPage,
    searchValue,
    setPage,
    setRowsPerPage,
    setSearchValue,
  },
}: Props) => {
  const navigate = useNavigate();
  const [isOpenFilterDialog , setIsOpenFilterDialog] = useState(false)
   

  return (
    <SideNavLayout>
      <div className="flex flex-col  p-4">
        {/* Page Header */}
        <div className="p-4">
          <ATMPageHeader  
          onFilterClick={()=>{setIsOpenFilterDialog(true)}}
          isFilter
            pageTitle="Students"
            searchValue={searchValue}
            onSearchChange={setSearchValue}
            hideAddButton={!isCheckActionsPermission({
              moduleName: UserModuleNameTypes.STUDENT,
              actionName: UserModuleActionTypes.ADD,
            })}
            buttonProps={{
              btnName: "Add New",
              onClick: () => {
                navigate("add");
              },
            }}
          />
        </div>

        {/* Table */}
        <div className="flex-1 overflow-auto flex flex-col">
          <ATMTable
            columns={columns}
            rows={rows}
            rowExtraClasses={() => "min-h-[40px]"}
            isLoading={isTableLoading}
            onRowClick={(row:any)=>{ isCheckActionsPermission({
              moduleName: UserModuleNameTypes.STUDENT,
              actionName: UserModuleActionTypes.EDIT,
            }) && navigate(`edit/${row?._id}/personal-information`)}}
          />
        </div>

        <div className="p-4 py-2 flex justify-end">
          <ATMPagination
            page={page}
            rowsPerPage={rowsPerPage}
            onPageChange={setPage}
            onRowsPerPageChange={setRowsPerPage}
            rowCount={totalItems}
            rows={rows}
          />
        </div>
      </div>
      {isOpenFilterDialog && <StudentFilterDialogWrapper onClose={()=>{setIsOpenFilterDialog(false)}} />}
    </SideNavLayout>
  );
};

export default StudentListing;
